import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

function Head({ description, lang, meta, title }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            siteUrl
            image
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description

  const renderShema = () => {
    const schema = {
      "@context": "http://schema.org",
      "@type": "LocalBusiness",
      address: {
        "@type": "PostalAddress",
        addressLocality: "Challans, France",
        postalCode: "85300",
        streetAddress: "183 rue Carnot",
      },
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: "4.8",
        reviewCount: "22",
      },
      image: `${site.siteUrl}${site.image}`,
      openingHours: ["Mo-Fr 9:00-19:00", "Sa 9:30-13:00"],
      telephone: "( 33 2) 28 10 75 82",
      url: "https://www.courtier-pret-immobilier-vendee.fr",
      name: "Courtier Prêt Immo",
      description: "Courtier en prêts hypothécaires à Challans.",
    }
    return <script type="application/ld+json">{JSON.stringify(schema)}</script>
  }

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title || site.siteMetadata.title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title || site.siteMetadata.title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(meta)}
    >
      {renderShema()}
    </Helmet>
  )
}

Head.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

Head.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string,
}

export default Head
